module.exports = __webpack_public_path__ + "static/media/retweetOutlined.99bf2f1d.svg";